import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-block-facilities',
    templateUrl: './block-facilities.component.html',
    styleUrls: ['./block-facilities.component.scss'],
    standalone: false
})
export class BlockFacilitiesComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
